export default __webpack_public_path__ + "static/media/3334 knife block C side.b15da979.png";